import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'

import Img from '../images/png/404.png'

class PageNotFound extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props)
        this.state = {}
        this.base_state = this.state
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    async componentDidMount() {
        this._isMounted = true
    }

    handleClick__link = target => async evt => {
        evt.preventDefault()
        this.props.history.push(target)
    }

    render() {
        const { t } = this.props

        return (
            <div className="page-wrapper">
                <Helmet>
                    <title>{t('_pages._page_not_found.title')} | Interacty</title>
                </Helmet>

                <div className="page page--page-not-found" data-structure="1">
                    <div className="img">
                        <img src={Img} alt="" />
                    </div>
                    <h1>{t('_pages._page_not_found.title')}</h1>
                    <h2>{t('_pages._page_not_found.sub_title')}</h2>
                    <div className="btns">
                        <button
                            className="button"
                            data-size="lg"
                            data-variant="primary"
                            onClick={this.handleClick__link(`/`)}
                        >
                            {t('_pages._page_not_found.back_to_home')}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default compose(connect(null, null), withTranslation('translations'))(PageNotFound)
